export default __webpack_public_path__ + "static/blank-5dd303f15b5f5cf41b3d013a0784e9b5.jpg";